exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".oz-modal-container-height[data-v-e55b5e10] {\n  max-height: calc(100% - 112px);\n  transition: min-height 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.shadow-z5[data-v-e55b5e10] {\n  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);\n}\n", ""]);

